// Visual quota indicator. Shows how much storage the offline layer
// is currently using compared to the browser-granted quota.
//
// Re-fetches every few seconds while mounted so the bar updates
// after a song is cached or removed.

import { useEffect, useState } from 'react'
import { getQuota, formatBytes, type QuotaInfo } from '../../lib/offline/quota'

const REFRESH_MS = 4000

export function QuotaBar() {
  const [info, setInfo] = useState<QuotaInfo | null>(null)

  useEffect(() => {
    let cancelled = false

    async function refresh() {
      const next = await getQuota()
      if (!cancelled) setInfo(next)
    }

    void refresh()
    const interval = setInterval(refresh, REFRESH_MS)

    return () => {
      cancelled = true
      clearInterval(interval)
    }
  }, [])

  if (!info || info.quotaBytes === 0) {
    return (
      <div className="text-xs text-text-muted">
        Speichernutzung nicht verfuegbar
      </div>
    )
  }

  const barColor =
    info.percent > 90
      ? 'bg-error'
      : info.percent > 70
        ? 'bg-yellow-400'
        : 'bg-primary'

  return (
    <div className="space-y-1">
      <div className="h-2 w-full overflow-hidden rounded-full bg-surface-lighter">
        <div
          className={`h-full transition-all ${barColor}`}
          style={{ width: `${Math.max(2, info.percent)}%` }}
        />
      </div>
      <div className="flex justify-between text-xs text-text-muted">
        <span>
          {formatBytes(info.usedBytes)} von {formatBytes(info.quotaBytes)} belegt
        </span>
        <span>{Math.round(info.percent)}%</span>
      </div>
    </div>
  )
}
